import moment from "moment";
import _ from "lodash";
import log2 from "../../utils/log2";

const log = log2("agentActivity");
const totalSecondsInADay = 24 * 60 * 60;
const calculatePercent = (activity, startDay, isLast, agentName) => {
    let { isOnline, status, createdDate, endDate } = activity;
    createdDate = moment(createdDate).isBefore(startDay) ? startDay : createdDate;
    const endOfDay = moment(createdDate).endOf("day");
    if (!!endDate) {
        log.debug("endDate check", {
            endDate,
            valid: !moment(endDate).isAfter(endOfDay),
            endTS: moment(createdDate).endOf("day").valueOf(),
            agentName,
        });
        endDate = moment(endDate).isAfter(endOfDay) ? endOfDay.valueOf() : endDate;
    } else {
        endDate = endOfDay.valueOf();
    }
    const isToday = moment().isSame(startDay, "day");
    log("calculatePercent", { activity, startDay, isLast, isToday, createdDate, agentName });
    const durationInSeconds = endDate
        ? moment(endDate).diff(moment(createdDate), "seconds")
        : isLast
        ? moment().diff(moment(createdDate), "seconds")
        : moment(startDay).endOf("day").diff(moment(createdDate), "seconds");
    const percent = (durationInSeconds / totalSecondsInADay) * 100;
    const isAcceptingChat = isOnline && status === "Online";
    const isNotAcceptingChat = isOnline && status !== "Online";
    const isLoggedOut = !isOnline;
    const result = [
        {
            isOnline,
            status,
            percent,
            isAcceptingChat,
            isNotAcceptingChat,
            isLoggedOut,
            duration: durationInSeconds,
            startTS: createdDate,
        },
    ];
    if (isToday && isLast && !endDate) {
        log("zero padding", {
            duration: moment(createdDate).endOf("day").diff(moment(), "seconds"),
            agentName,
        });
        const zeroPaddingSeconds = moment(createdDate).endOf("day").diff(moment(), "seconds");
        const zeroPaddingPercent = (zeroPaddingSeconds / totalSecondsInADay) * 100;
        result.push({
            isOnline: false,
            status: "Offline",
            percent: zeroPaddingPercent,
            isAcceptingChat: false,
            isNotAcceptingChat: false,
            isLoggedOut: true,
            duration: zeroPaddingSeconds,
            startTS: createdDate,
        });
    }
    return result;
};
/**
 * @param activities
 * @param lastActivity
 * @param startDay
 * @returns {{duration: *|number, isAcceptingChat: boolean, isLoggedOut: boolean, isOnline: *, isNotAcceptingChat: boolean, percent: number, status: *}[]|*[]|*}
 */
export const getPercentsFromUserActions = (activities, lastActivity, startDay, agentName) => {
    log("getPercentsFromUserActions", { activities, lastActivity, startDay, agentName });
    if (activities.length === 0) {
        if (lastActivity) {
            const arr = [
                {
                    ...lastActivity,
                    endDate: null,
                },
            ];
            log("activities is empty and lastActivity found - Step 1", { arr, activities, lastActivity, agentName });
            return arr.flatMap((activity, i) => calculatePercent(activity, startDay, true, agentName));
        } else {
            log("activities is empty and lastActivity not found - Step 2", { activities, lastActivity, agentName });
            return [
                {
                    isOnline: false,
                    status: "Offline",
                    percent: 100,
                    isAcceptingChat: false,
                    isNotAcceptingChat: false,
                    isLoggedOut: true,
                    duration: totalSecondsInADay,
                    startTS: startDay,
                },
            ];
        }
    }
    const head = activities[0];
    if (moment(head.createdDate).isAfter(startDay)) {
        if (lastActivity) {
            const arr = [
                {
                    ...lastActivity,
                    createdDate: startDay,
                    endDate: head.createdDate,
                },
                ...activities,
            ];
            log("activities is not empty and head is after startDay  and lastActivity found - Step 3", {
                arr,
                activities,
                lastActivity,
                agentName,
            });
            return arr.flatMap((activity, i) => calculatePercent(activity, startDay, i === arr.length - 1, agentName));
        } else {
            const arr = [
                {
                    createdDate: startDay,
                    endDate: head.createdDate,
                    isOnline: false,
                    status: "Offline",
                },
                ...activities,
            ];
            log("activities is not empty and head is after startDay  and lastActivity not found - Step 4", {
                arr,
                activities,
                lastActivity,
                agentName,
            });
            return arr.flatMap((activity, i) => calculatePercent(activity, startDay, i === arr.length - 1, agentName));
        }
    } else {
        log("activities is not empty and head is before startDay - Step 5", { activities, lastActivity, agentName });
        return activities.flatMap((activity, i) =>
            calculatePercent(activity, startDay, i === activities.length - 1, agentName)
        );
    }
};

/**
 *
 * @param percents
 * @returns {{acceptingChatDuration:Number,notAcceptingChatDuration:Number,loggedOutDuration:Number}}
 */
export const calculateStatus = (percents) => {
    log("calculateStatus", { percents });
    return percents.reduce(
        (acc, curr) => {
            if (curr.isAcceptingChat) {
                acc.acceptingChatDuration += curr.duration;
            } else if (curr.isNotAcceptingChat) {
                acc.notAcceptingChatDuration += curr.duration;
            } else if (curr.isLoggedOut) {
                acc.loggedOutDuration += curr.duration;
            }
            return acc;
        },
        {
            acceptingChatDuration: 0,
            notAcceptingChatDuration: 0,
            loggedOutDuration: 0,
        }
    );
};
